import { fetchWithHeaders, parseResponse } from '../shared/utils'

export function initiateBeatportAuth() {
  return fetchWithHeaders('/auth/beatport', {
    method: 'GET',
  }).then(parseResponse)
}
